module.exports = __webpack_public_path__ + "media/src/assets/images/lps-graph-238392205101c12e4456832e2409bca8.png";